import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import GradingSchemesLoader from "./GradingSchemesLoader";
import { Keys } from "../Constants";
import { getApplication } from "../../../../store/Selectors";
import { setField } from "../../../../store/Actions/Actions";
import useGradingSchemesApi from "./useGradingSchemesApi";
import useUiGradingSchemes from "./useUiGradingSchemes";
var Question6 = function Question6(_ref) {
  var formValidated = _ref.formValidated,
    dispatch = _ref.dispatch,
    degree = _ref.degree,
    educationCountry = _ref.educationCountry,
    value = _ref.value;
  var allGradingSchemes = useGradingSchemesApi(educationCountry.code, degree);
  var apiGradingSchemes = useMemo(function () {
    if (allGradingSchemes === null) {
      return null;
    }
    return allGradingSchemes.filter(function (scheme) {
      return scheme.active || String(value.gradingSchemeId) === String(scheme.id);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: fix this
  }, [allGradingSchemes]);
  var uiGradingSchemes = useUiGradingSchemes(apiGradingSchemes);
  if (apiGradingSchemes === null) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, null);
  }
  function storeValue(newValue) {
    dispatch(setField({
      key: Keys.Application.mostRecentOverallGrade,
      value: newValue
    }));
  }
  function handleChange(newValue) {
    storeValue(newValue);
  }
  return /*#__PURE__*/React.createElement(GradingSchemesLoader, {
    formValidated: formValidated,
    value: value,
    onChange: handleChange,
    gradingSchemes: uiGradingSchemes
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var applicationData = getApplication(state);
  return {
    educationCountry: applicationData.educationCountry,
    degree: applicationData.degree,
    value: applicationData[Keys.Application.mostRecentOverallGrade]
  };
};
var connector = connect(mapStateToProps);
export default connector(Question6);